<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <Select v-model="search.siteMn" style="width: 7.8em" placeholder="请选择站点" clearable>
          <Option v-for="item in siteList" :value="item.mn" :key="item.mn">{{ item.name }}</Option>
        </Select>
        <i-button type="default" @click="getData" style="margin-left: 1em;">搜索</i-button>
      </div>
      <div class="active">
        <i-button type="primary" @click="addData">添加</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)" style="text-align:right;margin-top: 1em" />
      <Spin fix v-show="table.loading"></Spin>
    </div>

    <!-- 表单对话框 -->
    <Modal :title="modal.title" v-model="modal.show" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="站点：" prop="siteMn">
          <!-- change保存站点图片 -->
          <Select v-model="formValidate.siteMn" clearable>
            <Option v-for="item in siteList" :value="item.mn" :key="item.mn">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="DTU设备编号：" prop="dtuId">
          <i-input v-model="formValidate.dtuId" placeholder="输入设备编号"></i-input>
        </FormItem>
        <FormItem label="备注信息：" prop="remark">
          <i-input v-model="formValidate.remark" placeholder="输入设备名称"></i-input>
        </FormItem>
      </Form>

      <div slot="footer">
        <i-button type="primary" @click="activeData">{{ modal.title }}</i-button>
        <i-button style="margin-left: 1em;" @click="modal.show = false">取消</i-button>
      </div>
    </Modal>

    <!-- 提示对话框 -->
    <alert-p :modalAlert="alert.show" title="警告提醒" content="确定要删除吗？" @cansel="alert.show = false" @makeSure="delData"
      :modal_loading="alert.loading"></alert-p>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
  position: relative;
}

.content {
  width: 700px;

  img {
    width: 100%;
  }
}
</style>

<script>
import toolbar from "../toolBar.vue";
import { timeStamp } from "../../../util/common/date";
import LoadImg from "../../../components/Load_img.vue";
import WarnRule from "../warnBind.vue";

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: "站点名称",
            key: "siteName",

            align: "center"
          },
          {
            title: "DTU设备编号",
            key: "dtuId",

            align: "center"
          },
          {
            title: "是否启用",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h("i-switch", {
                  props: {
                    size: "large",
                    value: params.row.isEnable,
                    loading: this.table.isEnable_loading
                  },
                  on: {
                    "on-change": value => {
                      // 是否启用切换
                      this.table.isEnable_loading = true; // 开启loading
                      this.$api.Deploy.postAlarmEdit(
                        {
                          content: { id: params.row.id, isEnable: value }
                        },
                        ["uuid", "company"]
                      )
                        .then(res => {
                          if (res.code == 0) {
                            this.table.isEnable_loading = false;
                            this.$Message.success("切换成功");
                          } else {
                            this.table.isEnable_loading = false;
                            this.$Message.warning(res.message);
                          }
                        })
                        .catch(err => {
                          this.table.isEnable_loading = false;
                        });
                    }
                  }
                })
              ]);
            }
          },
          {
            title: "报警器说明",
            key: "remark",

            align: "center"
          },
          {
            title: "操作",
            align: "center",
            width: 160,
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "更新";
                        this.modal.show = true;
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        this.formValidate = {
                          dtuId: params.row.dtuId,
                          remark: params.row.remark,
                          siteMn: params.row.siteMn,
                          id: params.row.id
                        };
                        this.activeData();
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.alert.id = params.row.id;
                        this.alert.show = true;
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 10,

        total: 0,
        loading: true,
        isSystem_loading: false // 切换启用状态loading
      },
      // 查询
      search: {
        siteMn: null // 站点编号
      },
      // 表单
      modal: {
        show: false, // 表单modal显示隐藏
        title: "添加"
      },
      // 表单数据
      formValidate: {
        siteMn: "", // 站点编号
        remark: "", // 设备名称
        dtuId: "" // 设备编号
      },
      // 验证
      ruleValidate: {
        siteMn: [
          {
            required: true,
            message: "请选择",
            trigger: "change"
          }
        ],
        dtuId: [
          { required: true, message: "不能为空", trigger: "blur" }
        ],
        remark: [
          { required: true, message: "不能为空", trigger: "blur" }
        ],
      },
      // alert提示组件
      alert: {
        show: false,
        loading: false,
        id: ""
      },
      siteList: [], //站点枚举
    };
  },
  components: {
    toolbar,
    LoadImg,
    WarnRule
  },
  created() {
    this.getData(); // 数据初始化
    this.getSiteEnum();
  },
  methods: {
    addData() {
      // 打开表单添加
      this.modal.title = "添加";
      this.modal.show = true;
      this.formValidate = {
        siteMn: "", // 站点编号
        remark: "", // 报警器描述
        dtuId: "" // wdtu编号
      };
      this.$refs.formValidate.resetFields(); // 清除验证错误
    },
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Deploy.getAlarmList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search
        },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    delData() {
      // 删除数据
      let id = this.alert.id; // 点击删除时对应的id
      if (id) {
        // 删
        this.alert.loading = true;
        this.$api.Deploy.getAlarmDel({ content: { id: id } }, [
          "uuid",
          "company"
        ])
          .then(res => {
            this.alert.show = false;
            if (res.code == 0) {
              this.alert.loading = false;
              this.$Notice.success({
                title: "删除成功",
                desc: ""
              });
              this.getData();
            } else {
              this.alert.loading = false;
              this.$Notice.warning({
                title: "删除失败",
                desc: res.message || "请联系管理员"
              });
            }
          })
          .catch(err => {
            this.alert.show = false;
            this.alert.loading = false;
          });
      } else {
        // 不存在id说明异常
        this.alert.show = false;
        this.$Notice.warning({
          title: "删除失败",
          desc: "数据异常，请联系管理员"
        });
      }
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    activeData() {
      //增、改操作
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          let params = this.formValidate;
          // 表单验证是否通过
          if (this.modal.title == "添加") {
            this.$api.Deploy.postAlarmAdd({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "添加成功",
                  desc: "添加成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "添加失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          } else {
            this.$api.Deploy.postAlarmEdit({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          }
        }
      });
    },
    // 获取站点枚举值
    getSiteEnum() {
      this.$api.Enum.getSiteEnum(null, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.siteList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取站点枚举失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },

  }
};
</script>